/**
 * 用户动态
 */
import dynamicApi from '../../api/dynamic.api'

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    // 获取动态列表
    getDynamicList({}, params) {
        return dynamicApi.getList(params);
    },
    // 获取动态项信息
    getDynamicItem({}, params) {
        return dynamicApi.getItem(params.key, params.correlationId);
    },
    // 点赞
    like({}, id) {
        return dynamicApi.like(id);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/dynamic.js